import React, { useState } from "react";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { User, Lightbulb, Code, BookOpen, Compass } from "lucide-react";
import "./../../../../assets/css/general/Homelayout/AITutor/AITutor.css";

const AITutor = () => {
  const [mousePos, setMousePos] = useState({ x: 0, y: 0 });
  const navigate = useNavigate();
  const handleChatClick = () => {
     sessionStorage.setItem("scrollPosition", window.scrollY);
    navigate("/techify-ai");
  };
  return (
    <section
      className="aitutor-section"
      onMouseMove={(e) => setMousePos({ x: e.clientX, y: e.clientY })}
    >
      <div className="aitutor-container">
        {/* Main Card - No Sharp Borders, Pure Organic Glow */}
        <div className="aitutor-mainCard">
          <div className="aitutor-mainContent">
            {/* Left Side - Hero Header */}
            <div className="aitutor-leftContent">
              <h2 className="aitutor-heading">
                Meet Your
                <br />
                <span className="aitutor-headingGradient">Techify AI</span>
              </h2>
              <p className="aitutor-description">
                Get instant clear explanations to help to help tot to learn
                questions, to help reical lsuppdotes is learn questions,
                practice, and grow smarter — anytime.
              </p>
              <button onClick={handleChatClick} className="aitutor-button">
                <span>Learn Smarter with your AI BUDDY</span>
                <div className="aitutor-buttonGlow"></div>
              </button>
            </div>

            {/* Right Side - Chat Preview */}
            <div className="aitutor-rightContent">
              <div className="aitutor-userCard">
                <div className="aitutor-userLabel">HELLO</div>
                <div className="aitutor-spacer6"></div>
                <div className="aitutor-userMessage">
                  What you want to know my friend
                  <br />
                </div>
              </div>

              <div className="aitutor-aiCard">
                <div className="aitutor-aiHeader">
                  <span className="aitutor-aiLabel">AI Buddy</span>
                  <div className="aitutor-aiAvatar">
                    <User size={14} strokeWidth={2.5} color="#f9f6ee" />
                  </div>
                </div>
                <div className="aitutor-spacer8"></div>
                <div className="aitutor-aiContent">
                  <p className="aitutor-aiText">
                    • <strong>Backpropagation</strong> is algorithm used to
                    train
                    <br />
                    &nbsp;&nbsp;neural networks. It works by:
                  </p>
                  <p className="aitutor-aiText">
                    • <strong>1. Forward Pass:</strong> Input data fed fela
                    <br />
                    &nbsp;&nbsp;network.
                  </p>
                  <p className="aitutor-aiText aitutor-noMargin">
                    • <strong>2. Error Calculation:</strong> A compared to th
                    <br />
                    &nbsp;&nbsp;expected output. network.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Feature Cards Grid */}
        <div className="aitutor-featureGrid">
          <FeatureCard
            icon={<Lightbulb size={28} strokeWidth={1.5} />}
            label="Concept Clarity"
            mousePos={mousePos}
          />
          <FeatureCard
            icon={<Code size={28} strokeWidth={1.5} />}
            label="Code Review"
            mousePos={mousePos}
          />
          <FeatureCard
            icon={<BookOpen size={28} strokeWidth={1.5} />}
            label="Quick Revision"
            mousePos={mousePos}
          />
          <FeatureCard
            icon={<Compass size={28} strokeWidth={1.5} />}
            label="Explore Topics"
            mousePos={mousePos}
          />
        </div>
      </div>
    </section>
  );
};

const FeatureCard = ({ icon, label, mousePos }) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div
      className={`aitutor-featureCard ${
        isHovered ? "aitutor-featureCardHover" : ""
      }`}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div
        className={`aitutor-iconContainer ${
          isHovered ? "aitutor-iconContainerHover" : ""
        }`}
      >
        {React.cloneElement(icon, { color: "#6B4C3E" })}
      </div>
      <div className="aitutor-featureLabel">{label}</div>
    </div>
  );
};

export default AITutor;
